import { consumeModalAutoDisplay } from '../../utils/modalAutoDisplay';
import React, { useState, useEffect } from 'react';
import { IComponentImage } from '../../component';
import { formatImage } from '../../utils/util';
import { style } from '../../utils/image';
import ComponentLink from '../ComponentLink';
import classNames from 'classnames';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import './Image.scss';
import { createPortal } from 'react-dom';

const ModalMap = (props: {
  modalMap: any;
  btn: any;
  setModalMap: (content: any) => void;
}) => {
  const { modalMap, setModalMap, btn } = props;
  return createPortal(
    <div
      className={
        'pendent-modal ' + (modalMap[`${btn.link!.modalcontent}`] ? 'show' : '')
      }
    >
      <div className="wrapper">
        <img src={style(btn.link!.modalcontent, 'wx_560_n')} />
      </div>
      <div
        className="close"
        onClick={() => {
          let newModalMap = {
            ...modalMap,
            [String(btn.link!.modalcontent)]: false
          };
          clearAllBodyScrollLocks();
          setModalMap(newModalMap);
        }}
      >
        <img src={require('../../assets/x-white.png')} />
      </div>
    </div>,
    document.body
  );
};

const Image = function(props: IComponentImage) {
  const { mode, images } = props;
  const len = +mode;
  const imageLength = (images || []).length;

  // 只渲染mode个，不足mode个的话显示mode个
  const cls = classNames('one-image', `column-${mode}`);

  const [modalMap, setModalMap] = useState({} as any);

  const onClick = (one: any) => {
    let { link } = one;
    if (link && link.type && link.type == 'modal-image') {
      let newModalMap = {
        ...modalMap,
        [String(link.modalcontent)]: true
      };
      setModalMap(newModalMap);
      // disableBodyScroll(document.body);
    } else {
      link && ComponentLink.to(link);
    }
  };

  const modalButtons = (images || []).filter((btn, index) => {
    return btn && btn.link && btn.link.type == 'modal-image';
  });

  useEffect(() => {
    // 检测一下有没有需要自动弹出的内容
    if (modalButtons && modalButtons.length) {
      modalButtons.forEach((btn, index) => {
        if (btn && btn.link && btn.link.modalauto) {
          if (consumeModalAutoDisplay(btn.link)) {
            let newModalMap = {
              ...modalMap,
              [String(btn.link.modalcontent)]: true,
            };
            setModalMap(newModalMap);
            disableBodyScroll(document.body);

          }
        }
      });
    }
  }, [modalButtons && modalButtons.length]);

  return imageLength ? (
    <div className="component-image-wrapper">
      {Array(len)
        .fill('')
        .map((value, index) => {
          if (index < imageLength) {
            const one = images[index];
            // 有图片的
            return (
              <ComponentLink.Wrapper lunchId={props.cid + '_' + index} link={one.link} key={index} placeImage={one.image ? window.location.protocol + formatImage(one.image) : ''}>
                <img
                  key={index}
                  className={cls}
                  // 修复一个undefined的图片加载
                  src={one.image ? formatImage(one.image) : ''}
                  alt=""
                  onClick={() => onClick(one)}
                />
              </ComponentLink.Wrapper>
            );
          } else {
            // return <div key={index} className={cls} />;
          }
        })}

      {modalButtons && modalButtons.length ? (
        <>
          {modalButtons.map((btn, index) => {
            return (
              <ModalMap
                key={index}
                btn={btn}
                modalMap={modalMap}
                setModalMap={setModalMap}
              />
            );
          })}
        </>
      ) : null}
    </div>
  ) : (
    <div />
  );
};

export default Image;
